


































































































































































import { numberHigherRule } from "@/lib/rules/numberHigherRule";
import { CustomerContractRate, ICustomerContractRate } from "@/models/customer-contract-rate.entity";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CustomFieldBoolean from "../report/CustomFieldBoolean.vue";

@Component({
  components: {
    CustomFieldBoolean
  }
})
export default class CustomerContractForm extends Vue {
  @Prop({ required: true }) value!: ICustomerContractRate;
  @Prop({ default: false }) isEditing!: boolean;

  localDetails: ICustomerContractRate = new CustomerContractRate({});

  @Watch("value", { immediate: true, deep: true })
  onDetailsChange(val: ICustomerContractRate) {
    this.localDetails = val;
  }

  @Watch("localDetails", { deep: true })
  onLocalDetailsChange() {
    this.$emit("update:value", this.localDetails);
  }

  onFieldChanged(labelKey: string) {
    if (!this.isEditing) return;
    this.$emit("field-changed", labelKey);
  }

  get greaterThanZeroRule() {
    return [numberHigherRule(0)];
  }
}
